<template>
  <v-container class="pa-0">
    <loading-spinner v-if="loading"></loading-spinner>
    <v-row v-else>
      <v-col cols="12">
        <v-card>
          <v-card-text class="py-0">
            <v-row dense>
              <v-col>
                <v-card-title>Partner Management</v-card-title>
                <v-card-subtitle>
                  Companies that are partners with CoreCounts
                </v-card-subtitle>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="partners"
              :footer-props="{
                'items-per-page-options': [10, 25, 50, 100]
              }"
              @click:row="rowClick"
              class="row-pointer"
              :loading="loading"
            >
              <template v-slot:item.name="{ item }">
                <team-chip :team="item"></team-chip>
              </template>
              <template
                v-slot:item.customerUserRecords.value.completion="{ item }"
              >
                <simple-engagement-text
                  :engagement="item.customerUserRecords.value"
                ></simple-engagement-text>
              </template>
              <template v-slot:item.customerScore.value="{ item }">
                <v-row
                  dense
                  v-if="item.customerScore && item.customerScore.value"
                >
                  <v-col cols="auto">
                    <v-img
                      :src="
                        $coreScores.getOverallImage(item.customerScore.value)
                      "
                      height="25"
                      width="25"
                      contain
                    ></v-img>
                  </v-col>
                  <v-col class="my-auto">
                    {{ item.customerScore.value | no_decimal }}
                  </v-col>
                </v-row>
              </template>
              <template v-slot:item.customerScore.percentChange="{ item }">
                <compare-text
                  v-if="item.customerScore"
                  :old-value="item.customerScore.compare"
                  :new-value="item.customerScore.value"
                  inherit
                  :timeframeId="1"
                ></compare-text>
              </template>
              <template v-slot:item.actions="{}">
                <v-btn icon>
                  <v-icon>keyboard_arrow_right</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import CompareText from "@/components/reporting/CompareText";
import SimpleEngagementText from "@/components/reporting/SimpleEngagementText";
export default {
  name: "PartnersList",
  components: { CompareText, SimpleEngagementText },
  data: () => ({
    tab: null,
    loading: false
  }),
  computed: {
    headers() {
      let items = [{ text: "Partner", value: "name" }];
      items = items.concat([
        { text: "Clients", value: "customerCount.value" },
        {
          text: "Client Participation",
          value: "customerUserRecords.value.completion"
        },
        { text: "Overall Score", value: "customerScore.value" },
        {
          text: "Trend",
          value: "customerScore.percentChange"
        },
        { text: "", value: "actions" }
      ]);
      return items;
    },
    ...mapGetters({
      partners: "customer/customers"
    })
  },
  created() {
    this.loadData();
  },
  methods: {
    rowClick(item) {
      this.$router.push({ path: `/portal/customers/${item.id}` });
    },
    loadData() {
      this.loading = true;
      this.$store
        .dispatch("customer/getPartners")
        .catch(error => {
          this.logError(error);
          this.$root.$alert(
            "Error Occurred",
            "An error occured while loading partners."
          );
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
